export default class AnnouncementBar {
  constructor(options) {
    this.$el = options.$el;
    this.$toggle = options.$toggle;

    this.$announcementBar = this.$el.find('.announcement-bar');
    this.$announcementBarClose = this.$el.find('[data-announcement-bar-close]');

    this._checkDismissAnnouncement();
    this._bindEvents();
  }

  _bindEvents() {
    this.$announcementBarClose.on('click.announcement-bar', event => {
      event.preventDefault();

      this._dismissAnnouncementBar();
    });
  }

  unload() {
    this.$announcementBarClose.off('.announcement-bar');
  }

  _checkDismissAnnouncement() {
    const now = new Date().getTime();
    const isDismissed = window.localStorage.getItem('dismiss-announcement-bar');

    if (!isDismissed) {
      this.$announcementBar.removeClass('dismissed');
    }

    // Remove cookie after 24 hours
    if (Math.abs(now - isDismissed > 60 * 60 * 24 * 1000)) {
      window.localStorage.removeItem('dismiss-announcement-bar', now);
    }
  }

  _dismissAnnouncementBar() {
    const now = new Date().getTime();
    const setDismiss = window.localStorage.getItem('dismiss-announcement-bar');

    if (setDismiss == null) {
      window.localStorage.setItem('dismiss-announcement-bar', now);
    }

    this.$announcementBar.addClass('dismissed');
  }
}
